import React from 'react';

const AppointmentNumberSvg = ({ color = '#006CDD', size = 20, ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none" {...props}>
        <path
            d="M15.8333 2.49967H12.35C12 1.53301 11.0833 0.833008 10 0.833008C8.91667 0.833008 8 1.53301 7.65 2.49967H4.16667C3.25 2.49967 2.5 3.24967 2.5 4.16634V17.4997C2.5 18.4163 3.25 19.1663 4.16667 19.1663H15.8333C16.75 19.1663 17.5 18.4163 17.5 17.4997V4.16634C17.5 3.24967 16.75 2.49967 15.8333 2.49967ZM10 2.49967C10.4583 2.49967 10.8333 2.87467 10.8333 3.33301C10.8333 3.79134 10.4583 4.16634 10 4.16634C9.54167 4.16634 9.16667 3.79134 9.16667 3.33301C9.16667 2.87467 9.54167 2.49967 10 2.49967ZM15.8333 17.4997H4.16667V4.16634H5.83333V6.66634H14.1667V4.16634H15.8333V17.4997Z"
            fill={color}
        />
    </svg>
);

export default AppointmentNumberSvg;
